export default {
  state: {
    workspaces: [],
  },
  getters: {
    getWorkspaces(state) {
      return state.workspaces
    }
  },
  mutations: {
    UPDATE_WORKSPACES(state, data) {
      state.workspaces = data
    }
  },
  actions: {
  },
}
